import IGlassWallDoor from 'components/interfaces/IGlassWallDoor';
import IWall from 'components/interfaces/IWall';

import calculateGlassLineLength from './calculateGlassLineLength';
import getAmountOfGlassAreas from './getAmountOfGlassAreas';
import getDoorPosition from './getDoorPosition';
import getDoorsFromWallParts from './getDoorsFromWallParts';
import handleFirstAndLastDoorSettings from './handleFirstAndLastDoorSettings';

const getFirstGlassAreaLength = (
  doors: IGlassWallDoor[],
  wall: IWall,
  totalGlassLength: number,
  glassStartPoint: number,
  glassEndPoint: number
): number => {
  if (doors.length === 0) {
    return totalGlassLength;
  }

  if (!doors[0].isFirstDoor) {
    return getDoorPosition(doors[0], wall).glass.left - glassStartPoint;
  }

  if (doors.length === 1) {
    return getLastGlassAreaLength(0, doors, wall, glassEndPoint);
  }

  return getMiddleGlassAreaLength(0, doors, wall);
};

const getLastGlassAreaLength = (
  glassAreaIndex: number,
  doors: IGlassWallDoor[],
  wall: IWall,
  glassEndPoint: number
): number => {
  if (doors[doors.length - 1].isLastDoor) {
    return getMiddleGlassAreaLength(glassAreaIndex, doors, wall);
  }

  const doorRightEdge = getDoorPosition(doors[doors.length - 1], wall).glass
    .right;

  return glassEndPoint - doorRightEdge;
};

const getMiddleGlassAreaLength = (
  glassAreaIndex: number,
  doors: IGlassWallDoor[],
  wall: IWall
): number => {
  const startDoorIndex = doors[0].isFirstDoor
    ? glassAreaIndex
    : glassAreaIndex - 1;

  const startDoor = doors[startDoorIndex];
  const endDoor = doors[startDoorIndex + 1];

  const startDoorEndPosition = getDoorPosition(startDoor, wall).glass.right;
  const endDoorStartPosition = getDoorPosition(endDoor, wall).glass.left;
  return endDoorStartPosition - startDoorEndPosition;
};

const getGlassAreaLength = (glassAreaIndex: number, wall: IWall): number => {
  const doors = handleFirstAndLastDoorSettings(
    getDoorsFromWallParts(wall).map((door) => ({
      ...door,
      totalAreaLength: getDoorPosition(door, wall).totalAreaLength,
    })),
    wall
  );

  const { glassEndPoint, glassStartPoint, totalGlassLength } =
    calculateGlassLineLength(wall);

  if (glassAreaIndex === 0) {
    return getFirstGlassAreaLength(
      doors,
      wall,
      totalGlassLength,
      glassStartPoint,
      glassEndPoint
    );
  }

  if (glassAreaIndex === getAmountOfGlassAreas(doors, wall) - 1) {
    return getLastGlassAreaLength(glassAreaIndex, doors, wall, glassEndPoint);
  }

  return getMiddleGlassAreaLength(glassAreaIndex, doors, wall);
};

export default getGlassAreaLength;
